import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class AddEdit extends React.Component {
    _isMounted = false;
    state = {
        modalShow: false,
        alert: 0,
        alertMessage: '',
        flag: false,
        UniqeID: this.props.selectedRow ? ' ' : this.props.UniqeID,
        isDisabled: this.props.selectedRow ? true : false,
        StoreTag: this.props.selectedRow ? this.props.selectedRow.StoreTag : '',
        lock_status: this.props.selectedRow
            ? this.props.selectedRow.lock_status
            : '',
        Password: this.props.selectedRow ? this.props.selectedRow.Password : '',
        Address: this.props.selectedRow ? this.props.selectedRow.Address : '',
        Area: this.props.selectedRow ? this.props.selectedRow.Area : '',
        City: this.props.selectedRow ? this.props.selectedRow.City : '',
        District: this.props.selectedRow ? this.props.selectedRow.District : '',
        PinCode: this.props.selectedRow ? this.props.selectedRow.PinCode : '',
        State: this.props.selectedRow ? this.props.selectedRow.State : '',
        EmailId: this.props.selectedRow ? this.props.selectedRow.EmailId : '',
        PhoneNumber: this.props.selectedRow
            ? this.props.selectedRow.PhoneNumber
            : '',
        StoreType: this.props.selectedRow
            ? this.props.selectedRow.StoreType
            : '',
        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: '',
        lockStatusOption: ['Unlocked', 'Locked'],
        AllStoreType: ['Easy', 'Non-Easy'],
        AllStates: [
            'Andhra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Andaman and Nicobar Islands',
            'Bihar',
            'Chandigarh',
            'Chhattisgarh',
            'Delhi',
            'Dadra and Nagar Haveli and Daman and Diu',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu and Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Ladakh',
            'Lakshadweep',
            'Madhya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Odisha',
            'Punjab',
            'Puducherry',
            'Rajasthan',
            'Sikkim',
            'Tamil Nadu',
            'Telangana',
            'Tripura',
            'Uttar Pradesh',
            'Uttarakhand',
            'West Bengal'
        ]
    };

    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        this._isMounted = true;
        
        if(!this.props.selectedRow){
        this.getProfileDetail()
        }
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    fieldsMapUtil = (data) => {
        
        
        let res = {};
        
        res = {
        ...res,
        Address: data.HouseNumber? data.HouseNumber : '',
        Area: data.Area? data.Area : '',
        City: data.City? data.City : '',
        District: data.District? data.District : '',
        PinCode: data.PinCode? data.PinCode : '',
        State: data.State? data.State : '',
        EmailId: data.EmailId? data.EmailId : '',
        PhoneNumber: data.PhoneNumber? data.PhoneNumber : '',
        lock_status:'Unlocked',
        StoreType:'Easy'
        
        };
        return res;
        
    };
    async getProfileDetail() {
        this.setState({
            flag: true,
        });

        let dataRow = {
            UniqeID: this.props.UniqeID,
            UserRole: this.props.selectedUserRole
        };
        
        await RestServices.getProfileDetail(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData) {
                        if (this._isMounted) {
                            
                            this.setState({
                                ...this.fieldsMapUtil(responseData.data),flag: false
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
    SubmitFormData = () => {
        let data = {
            UniqeID: this.state.UniqeID,
            lock_status: this.state.lock_status,
            Password: this.state.Password,
            UserType: this.props.storeTagOwner,
            StoreTag: this.state.StoreTag,
            Address: this.state.Address,
            City: this.state.City,
            Area: this.state.Area,
            PinCode: this.state.PinCode,
            State: this.state.State,
            District: this.state.District,
            PhoneNumber:'+91'+this.state.PhoneNumber.substring(this.state.PhoneNumber.length - 10),
            EmailId: this.state.EmailId,
            StoreType: this.state.StoreType.trim(),
            RequestedTimeStamp: this.state.RequestedTimeStamp
                ? this.state.RequestedTimeStamp
                : dateFormatUtil(),
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
        };
        
        var validationResult = this.validateForm(data);
        if (validationResult.isError) {
            if (this._isMounted) {
                this.setState({
                    alert: 1,
                    alertMessage: validationResult.errorMsg
                });
            }
        } else {
            this.setState({ flag: true, alert: 0, alertMessage: '' });
            
            RestServices.addEditStoreTagMapping(
                localStorage.getItem('FirebaseToken'),
                data
            )
                .then((response) => response.json())
                .then((responseData) => {
                    

                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (responseData.status) {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 2,
                                    alertMessage: responseData.message
                                });
                            }
                        } else {
                            if (this._isMounted) {
                                this.setState({
                                    flag: false,
                                    alert: 1,
                                    alertMessage: responseData.message
                                });
                            }
                        }
                    }
                })
                .catch((err) => {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: err.message
                        });
                    }
                });
        }
    };

    handleClose = () => {
        if (this._isMounted) {
            this.setState({ selectedRow: null, modalShow: false });
        }
    };

    confirmDelete = () => {
        if (this._isMounted) {
            this.setState({ modalShow: true });
        }
    };

    deleteStoreTag = async () => {
        let postData = {
            docId: this.props.selectedRow.docId
        };

        await RestServices.deleteStoreTag(
            localStorage.getItem('FirebaseToken'),
            postData
        )
            .then((response) => response.json())
            .then((data) => {
                if (this._isMounted) {
                    this.setState({ modalShow: false });
                    window.location.replace('store-tag-mapping');
                }

                if (data.error) {
                    if (this._isMounted) {
                        this.setState({ alert: 1, alertMessage: data.error });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Store Tag</Form.Label>
                        {this.state.isDisabled && (
                            <Form.Control
                                disabled
                                placeholder="Enter Store Tag"
                                type="text"
                                name="StoreTag"
                                value={this.state.StoreTag}
                                onChange={this.onChangeValues}
                            />
                        )}
                        {!this.state.isDisabled && (
                            <Form.Control
                                placeholder="Enter Store Tag"
                                type="text"
                                name="StoreTag"
                                value={this.state.StoreTag}
                                onChange={this.onChangeValues}
                            />
                        )}
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Lock Status</Form.Label>
                        <Autocomplete
                            name="lock_status"
                            value={this.state.lock_status}
                            onChange={(event, newValue) => {
                                this.setState({ lock_status: newValue.trim() });
                            }}
                            id="lock_status"
                            options={this.state.lockStatusOption.map(
                                (arr) => arr
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Email Id</Form.Label>
                        <Form.Control
                            placeholder="Enter Email Id"
                            type="email"
                            name="EmailId"
                            value={this.state.EmailId}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            placeholder="Enter Password"
                            type="password"
                            name="Password"
                            value={this.state.Password}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                            placeholder="Enter Mobile Number"
                            type="text"
                            name="PhoneNumber"
                            value={this.state.PhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Store Type</Form.Label>
                        <Autocomplete
                            name="StoreType"
                            value={this.state.StoreType}
                            onChange={(event, newValue) => {
                                this.setState({ StoreType: newValue.trim() });
                            }}
                            id="user_StoreType"
                            options={this.state.AllStoreType.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Store Address</Form.Label>
                        <Form.Control
                            placeholder="Enter Store Address"
                            type="text"
                            name="Address"
                            value={this.state.Address}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Area</Form.Label>
                        <Form.Control
                            placeholder="Enter Area"
                            type="text"
                            name="Area"
                            value={this.state.Area}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            placeholder="Enter City/Town"
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Pin Code</Form.Label>
                        <Form.Control
                            placeholder="Enter Pin Code"
                            type="text"
                            name="PinCode"
                            value={this.state.PinCode}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>District</Form.Label>
                        <Form.Control
                            placeholder="Enter District"
                            type="text"
                            name="District"
                            value={this.state.District}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>
                        <Autocomplete
                            name="State"
                            value={this.state.State}
                            onChange={(event, newValue) => {
                                this.setState({ State: newValue });
                            }}
                            id="user_State"
                            options={this.state.AllStates.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <hr />
                {this.state.isDisabled && (
                    <Form.Row>
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={this.SubmitFormData}
                        >
                            Update
                        </Button>
                        {this.props.role ==='Admin' &&<Button
                            style={{ marginLeft: '1rem' }}
                            variant="primary"
                            type="submit"
                            onClick={this.confirmDelete}
                        >
                            Delete
                        </Button>}
                    </Form.Row>
                )}

                {!this.state.isDisabled && (
                    <Form.Row>
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={this.SubmitFormData}
                        >
                            Submit
                        </Button>
                    </Form.Row>
                )}

                <Modal
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Are you sure you want to delete?</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.deleteStoreTag}>
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }

    validateForm = () => {
        let isError = false;
        let errorMsg = '';
        if (!this.state.manageMapping) {
            if (this.state.StoreTag == '') {
                isError = true;
                errorMsg = errorMsg + ' Please Select Store Tag.';
            }

            if (this.state.Address == '') {
                isError = true;
                errorMsg = errorMsg + ' Please enter Address.';
            }
            if (this.state.City == '') {
                isError = true;
                errorMsg = errorMsg + ' Please enter City.';
            }
            if (this.state.Area == '') {
                isError = true;
                errorMsg = errorMsg + ' Please enter Area.';
            }
            if (this.state.PinCode == '') {
                isError = true;
                errorMsg = errorMsg + ' Please enter Pin Code.';
            }
            if (this.state.State == '') {
                isError = true;
                errorMsg = errorMsg + ' Please enter State.';
            }
            if (this.state.District == '') {
                isError = true;
                errorMsg = errorMsg + ' Please enter District values.';
            }

            let PhoneNumber = this.state.PhoneNumber.replace('+91', '').trim();

            if (PhoneNumber.length != 10 || !PhoneNumber.match('[0-9]{10}')) {
                isError = true;
                errorMsg =
                    errorMsg + ' Please enter valid Primary Phone Number.';
            }

            if (
                !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                    this.state.EmailId
                )
            ) {
                isError = true;
                errorMsg = errorMsg + ' Please enter valid Personal Email Id.';
            }
        }

        var reurndate = [];
        reurndate.isError = isError;
        reurndate.errorMsg = errorMsg;
        return reurndate;
    };
}

export default AddEdit;
